import { create } from "zustand";
import type { IBrand } from "../types/models/brands.models.types";

interface IBrandsStore {
	data: IBrand[];
	setData: (data: IBrand[]) => void;
}

const useBrandsStore = create<IBrandsStore>((set) => ({
	data: [],
	setData: (data: IBrand[]) => set(() => ({ data })),
}));

export default useBrandsStore;
